export default __webpack_public_path__ + "6cde69c2f569a45912f7ac151485f16f.mp3";